import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'umi';
import { NewzooToDatabrain } from '@intelligence/utils/constant';

// import Newzoo from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import Newzoo from '@/pages/intelligence/assets/svg/dataSource/newzoo.svg';
import Newzoo from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';

export default function Filter(props: any) {
  const { className } = props;
  const { formatMessage } = useIntl();

  const sourceNode = (
    <>
      <img className="dbi-global-view-filter-tips-icon view-title-img" src={Newzoo} />
      <span>Newzoo</span>
    </>
  );

  return (
    <div className={classnames('dbi-global-view-filter-tips', className)}>
      {formatMessage({ id: 'dbi_global_view_genre_classification_data_source_tips' }, { source: sourceNode })}
    </div>
  );

  // return (
  //   <div className={classnames('dbi-global-view-filter-tips', className)}>
  //     <span>Genre classification and data come from</span>
  //     <img className="dbi-global-view-filter-tips-icon view-title-img" src={Newzoo} />
  //     <span>Newzoo.</span>
  //   </div>
  // );
}
